import React, { useState, useEffect } from 'react';

const API = '/api';

const tipoConfig = {
  offline:   { icono:'📡', label:'Sin comunicación',  color:'#f87171', bg:'#3a1a1a', border:'#f87171' },
  soc_bajo:  { icono:'🔋', label:'Batería baja',      color:'#f59e0b', bg:'#3a2a1a', border:'#f59e0b' },
  faulted:   { icono:'⚡', label:'Falla cargador',    color:'#f87171', bg:'#3a1a1a', border:'#f87171' },
  sin_carga: { icono:'🔌', label:'Sin carga',         color:'#a78bfa', bg:'#2a1a3a', border:'#a78bfa' },
  bateria:   { icono:'🔥', label:'Anomalía batería',  color:'#f59e0b', bg:'#3a2a1a', border:'#f59e0b' },
};

const severidadTag = s => {
  const map = { critica:['#3a1a1a','#f87171','Crítica'], alta:['#3a2a1a','#f59e0b','Alta'], media:['#1a2a3a','#60a5fa','Media'] };
  const [bg,col,label] = map[s]||['#2a2a2a','#888','Baja'];
  return <span style={{background:bg,color:col,padding:'2px 8px',borderRadius:'5px',fontSize:'11px',fontWeight:'600'}}>{label}</span>;
};

export default function Alertas() {
  const [alertas, setAlertas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('activas');
  const [filterTipo, setFilterTipo] = useState('');
  const [filterCop, setFilterCop] = useState('');
  const [sonido, setSonido] = useState(true);

  const fetchAlertas = () => {
    fetch(`${API}/alerts`)
      .then(r => r.json())
      .then(data => {
        // Normalizar campos snake_case
        const normalized = data.map(a => ({
          id: a.id,
          tipo: a.tipo,
          severidad: a.severidad,
          cargador: a.cp_id || a.cargador,
          cop: a.cop || '—',
          bus: a.bus || '',
          mensaje: a.mensaje,
          tiempo: a.created_at ? new Date(a.created_at).toLocaleString('es-CO') : '—',
          activa: a.activa === 1 || a.activa === true,
          resuelta: a.resolved_at ? new Date(a.resolved_at).toLocaleString('es-CO') : null,
        }));
        setAlertas(normalized);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchAlertas();
    const iv = setInterval(fetchAlertas, 15000); // actualiza cada 15 seg
    return () => clearInterval(iv);
  }, []);

  const resolver = async (id) => {
    await fetch(`${API}/alerts/resolve`, {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ id })
    });
    fetchAlertas();
  };

  const resolverTodas = async () => {
    await fetch(`${API}/alerts/resolve`, {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ all: true })
    });
    fetchAlertas();
  };

  const filtered = alertas.filter(a => {
    if (filtro==='activas' && !a.activa) return false;
    if (filtro==='resueltas' && a.activa) return false;
    if (filterTipo && a.tipo!==filterTipo) return false;
    if (filterCop && a.cop!==filterCop) return false;
    return true;
  });

  const activas = alertas.filter(a => a.activa);
  const criticas = activas.filter(a => a.severidad==='critica');

  if (loading) return <div style={{padding:'3rem',textAlign:'center',color:'#666'}}>Cargando alertas...</div>;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'1.5rem',flexWrap:'wrap',gap:'12px'}}>
        <div className="page-title" style={{margin:0}}>
          Alertas
          {activas.length > 0 && (
            <span style={{marginLeft:'10px',background:'#f87171',color:'#fff',borderRadius:'12px',padding:'2px 10px',fontSize:'14px',fontWeight:'600'}}>
              {activas.length}
            </span>
          )}
        </div>
        <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
          <button onClick={()=>setSonido(!sonido)}
            style={{padding:'6px 12px',background:'#1a1d27',border:'1px solid #2a2d3a',borderRadius:'7px',color:sonido?'#4ade80':'#666',cursor:'pointer',fontSize:'13px'}}>
            {sonido?'🔔 Sonido on':'🔕 Sonido off'}
          </button>
          <button onClick={fetchAlertas}
            style={{padding:'6px 12px',background:'#1a1d27',border:'1px solid #2a2d3a',borderRadius:'7px',color:'#aaa',cursor:'pointer',fontSize:'13px'}}>
            🔄 Refrescar
          </button>
          {activas.length > 0 && (
            <button onClick={resolverTodas}
              style={{padding:'6px 14px',background:'#1d6a3a',border:'none',borderRadius:'7px',color:'#fff',cursor:'pointer',fontSize:'13px'}}>
              ✅ Resolver todas
            </button>
          )}
        </div>
      </div>

      <div className="metrics">
        <div className="metric-card">
          <div className="metric-label">Alertas activas</div>
          <div className="metric-value" style={{color:activas.length>0?'#f87171':'#4ade80'}}>{activas.length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Críticas</div>
          <div className="metric-value" style={{color:'#f87171'}}>{criticas.length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Sin comunicación</div>
          <div className="metric-value" style={{color:'#f59e0b'}}>{activas.filter(a=>a.tipo==='offline').length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Resueltas</div>
          <div className="metric-value" style={{color:'#4ade80'}}>{alertas.filter(a=>!a.activa).length}</div>
        </div>
      </div>

      {criticas.length > 0 && (
        <div style={{background:'#3a1a1a',border:'1px solid #f87171',borderRadius:'10px',padding:'12px 16px',marginBottom:'1.25rem',display:'flex',alignItems:'center',gap:'12px'}}>
          <span style={{fontSize:'20px'}}>🚨</span>
          <span style={{color:'#f87171',fontSize:'13px',fontWeight:'500'}}>
            {criticas.length} alerta{criticas.length>1?'s':''} crítica{criticas.length>1?'s':''} — requiere atención inmediata
          </span>
        </div>
      )}

      <div className="filters">
        <div style={{display:'flex',gap:'0',border:'1px solid #2a2d3a',borderRadius:'7px',overflow:'hidden'}}>
          {['activas','resueltas','todas'].map(f=>(
            <button key={f} onClick={()=>setFiltro(f)}
              style={{padding:'6px 14px',border:'none',cursor:'pointer',fontSize:'13px',fontWeight:'500',
                background:filtro===f?'#2a2d3a':'#1a1d27',color:filtro===f?'#fff':'#666'}}>
              {f.charAt(0).toUpperCase()+f.slice(1)}
            </button>
          ))}
        </div>
        <select value={filterTipo} onChange={e=>setFilterTipo(e.target.value)}>
          <option value="">Todos los tipos</option>
          <option value="offline">Sin comunicación</option>
          <option value="soc_bajo">Batería baja</option>
          <option value="faulted">Falla cargador</option>
          <option value="sin_carga">Sin carga</option>
          <option value="bateria">Anomalía batería</option>
        </select>
        <select value={filterCop} onChange={e=>setFilterCop(e.target.value)}>
          <option value="">Todos los COP</option>
          <option value="Blanco y Negro">Blanco y Negro</option>
        </select>
        <span style={{fontSize:'12px',color:'#555',marginLeft:'auto'}}>{filtered.length} alertas · actualiza cada 15s</span>
      </div>

      {filtered.length === 0 ? (
        <div className="card" style={{textAlign:'center',padding:'3rem'}}>
          <div style={{fontSize:'40px',marginBottom:'12px'}}>✅</div>
          <div style={{color:'#4ade80',fontSize:'16px',fontWeight:'500'}}>
            {filtro==='activas' ? 'Sin alertas activas' : 'Sin alertas en este filtro'}
          </div>
          <div style={{color:'#555',fontSize:'13px',marginTop:'6px'}}>
            {filtro==='activas' ? 'Todos los cargadores operando normalmente' : 'Cambia el filtro para ver más'}
          </div>
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          {filtered.map(a => {
            const cfg = tipoConfig[a.tipo]||tipoConfig.offline;
            return (
              <div key={a.id} style={{
                background:a.activa?cfg.bg:'#1a1d27',
                border:`1px solid ${a.activa?cfg.border:'#2a2d3a'}`,
                borderRadius:'10px',padding:'14px 16px',
                display:'flex',alignItems:'flex-start',gap:'12px',
                opacity:a.activa?1:0.6
              }}>
                <span style={{fontSize:'22px',marginTop:'2px'}}>{cfg.icono}</span>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'4px',flexWrap:'wrap'}}>
                    <span style={{fontSize:'13px',fontWeight:'600',color:a.activa?cfg.color:'#aaa'}}>{cfg.label}</span>
                    {severidadTag(a.severidad)}
                    <span style={{fontSize:'11px',color:'#555'}}>{a.tiempo}</span>
                    {!a.activa && <span style={{fontSize:'11px',color:'#4ade80'}}>✓ Resuelta {a.resuelta}</span>}
                  </div>
                  <div style={{fontSize:'13px',color:'#ccc',marginBottom:'6px'}}>{a.mensaje}</div>
                  <div style={{display:'flex',gap:'12px',fontSize:'12px',color:'#666'}}>
                    {a.cop && <span>📍 {a.cop}</span>}
                    {a.cargador && <span>🔌 {a.cargador}</span>}
                    {a.bus && <span>🚌 {a.bus}</span>}
                  </div>
                </div>
                {a.activa && (
                  <button onClick={()=>resolver(a.id)}
                    style={{padding:'5px 12px',background:'#2a2d3a',border:'none',borderRadius:'6px',color:'#aaa',cursor:'pointer',fontSize:'12px',whiteSpace:'nowrap',marginTop:'2px'}}>
                    ✓ Resolver
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
